const API_BASE_URL = (import.meta.env.VITE_BASE_URL ?? '').replace(/\/+$/, '')

export const BASE_URL = `${API_BASE_URL}/server`
export const MINIO_BASE_URL = `${API_BASE_URL}/manage/dashboard`
export const MANAGE_BASE_URL = `${API_BASE_URL}/manage`
export const POEM_BASE_URL = `${API_BASE_URL}/ai/poem/create`
export const SRC_URL = `${API_BASE_URL}/server/getobjects?bucket=images&path=`
export const SEALINFO_URL = API_BASE_URL
export const SEGMENTINFO_URL = `${API_BASE_URL}/segment`
export const DOWNLOAD_URL = `${API_BASE_URL}/server/analysis/downloadworklist`
export const GRAPH_BASE_URL = `${API_BASE_URL}/painting/analysis/network`
export const AI_PREDICTION_URL = `${API_BASE_URL}/ai/predictions/resnet50_byol`
export const DOWNLOAD_PAGE_URL = `${API_BASE_URL}/server/download`
